import { FilterFieldGroup } from '@App/forms/common/filter-field-group'
import { FormFieldTypes } from '@App/enum/form-field-types'
import { CatalogTransferStatus } from '@Entities/rightsholder/catalog-transfer'
import { SearchPanelSortOption } from '@Components/Search/SearchPanel/types'

export type CatalogTransferStatusFilterType = CatalogTransferStatus

export type CatalogTransferSortByType = 'created_at' | 'updated_at'

export interface CatalogTransferFilter {
    statusFilter?: CatalogTransferStatusFilterType[] | undefined
    sort_by?: CatalogTransferSortByType | undefined
}

export const catalogTransferStatusFilterGroup: FilterFieldGroup<CatalogTransferFilter> = {
    name: 'Status Filter',
    allowMultiple: true,
    filterFields: [
        {
            statusFilter: {
                name: 'statusFilter',
                label: '',
                type: FormFieldTypes.CHECKBOX_GROUP,
                checkboxes: [
                    {
                        id: 'CREATING',
                        label: 'Draft',
                    },
                    {
                        id: 'SUBMITTED',
                        label: 'Submitted',
                    },
                    {
                        id: 'APPROVED',
                        label: 'Approved',
                    },
                    {
                        id: 'COMPLETE',
                        label: 'Complete',
                    },
                    {
                        id: 'REJECTED',
                        label: 'Rejected',
                    },
                ],
            },
        },
    ],
}

// Single source of truth for the sort options, shared by the filter-sidebar radio group below
// and the SearchPanel SortBy dropdown (kept in sync via sortFilterKey="sort_by" on SearchPanel).
const catalogTransferSortValues: Array<{ value: CatalogTransferSortByType; label: string; default?: boolean }> = [
    { value: 'created_at', label: 'Creation Date' },
    { value: 'updated_at', label: 'Last Updated', default: true },
]

export const catalogTransferSortByTypeFilterGroup: FilterFieldGroup<CatalogTransferFilter> = {
    name: 'Sort',
    allowMultiple: false,
    filterFields: [
        {
            SORT: {
                name: 'sort_by',
                type: FormFieldTypes.RADIO,
                options: catalogTransferSortValues.map(({ value, label, default: isDefault }) => ({
                    name: value,
                    label,
                    default: isDefault,
                })),
                label: '',
            },
        },
    ],
}

export const catalogTransferSortOptions: SearchPanelSortOption[] = catalogTransferSortValues.map(
    ({ value, label }) => ({ value, label })
)

export const CatalogTransferFilterCollection: Array<FilterFieldGroup<CatalogTransferFilter>> = [
    catalogTransferStatusFilterGroup,
    catalogTransferSortByTypeFilterGroup,
]
